import {Box} from '@mui/material';
import React from 'react';
import classNames from 'classnames';
import styles from './page-wrapper-v2.module.scss';

interface Props {
    children: React.ReactNode;
    className?: string;
    hasMobileFooter?: boolean;
}

export default function PageWrapperV2({ children, className, hasMobileFooter }: Props) {
    return (
        <Box className={classNames(styles.pageWrapper, className)}>
            <div className={classNames(styles.container, { [styles.containerNoFooter]: hasMobileFooter === false })}>
                {children}
            </div>
        </Box>
    );
}
